var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAmenities = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amenities",
    clipPath: "url(#clip0_4402_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 0H1.5C0.95 0 0.5 0.45 0.5 1V19C0.5 19.55 0.95 20 1.5 20H8.5C9.05 20 9.5 19.55 9.5 19V7.57C9.5 7.02 9.95 6.57 10.5 6.57H16.5C17.05 6.57 17.5 6.12 17.5 5.57V1C17.5 0.45 17.05 0 16.5 0ZM6.5 17.59C6.5 17.76 6.37 17.89 6.2 17.89H3.8C3.63 17.89 3.5 17.76 3.5 17.59V15.04C3.5 14.87 3.63 14.74 3.8 14.74H6.2C6.37 14.74 6.5 14.87 6.5 15.04V17.59ZM6.5 11.28C6.5 11.44 6.37 11.58 6.2 11.58H3.8C3.63 11.58 3.5 11.44 3.5 11.28V8.72C3.5 8.56 3.63 8.42 3.8 8.42H6.2C6.37 8.42 6.5 8.56 6.5 8.72V11.28ZM6.5 4.96C6.5 5.13 6.37 5.26 6.2 5.26H3.8C3.63 5.26 3.5 5.13 3.5 4.96V2.41C3.5 2.24 3.63 2.11 3.8 2.11H6.2C6.37 2.11 6.5 2.24 6.5 2.41V4.96Z",
    fill: "#131A2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 7.37H11.5C10.95 7.37 10.5 7.82 10.5 8.37V19C10.5 19.55 10.95 20 11.5 20H18.5C19.05 20 19.5 19.55 19.5 19V8.37C19.5 7.82 19.05 7.37 18.5 7.37ZM16.5 18.65C16.5 18.81 16.37 18.95 16.2 18.95H13.8C13.63 18.95 13.5 18.81 13.5 18.65V13.98C13.5 13.82 13.63 13.68 13.8 13.68H16.2C16.37 13.68 16.5 13.82 16.5 13.98V18.65Z",
    fill: "#131A2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAmenities, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/amenities.5880607b.svg";
export { ForwardRef as ReactComponent };